import { render } from "./genereal.vue?vue&type=template&id=6154f2f8&scoped=true"
import script from "./genereal.vue?vue&type=script&lang=js"
export * from "./genereal.vue?vue&type=script&lang=js"

import "./genereal.vue?vue&type=style&index=0&id=6154f2f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6154f2f8"]])

export default __exports__